module.exports = __webpack_public_path__ + "img/banner-rush.c301c405.jpg";